import Vue from "vue";
import Router from "vue-router";

// Base app router
import BaseAppRouter from "@/views/router.js";

//Projects
import ProjectsBase from "@/views/projects/TheBase.vue";
import ProjectsRouter from "@/views/projects/router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "LoginPage",
      component: () => import("@/views/authentification/LoginPage.vue")
    },

    {
      path: "/forgot-password",
      name: "ForgotPasswordPage",
      component: () => import("@/views/authentification/ForgotPasswordPage.vue")
    },

    {
      path: "/reset-password/:token",
      name: "ResetPasswordPage",
      component: () => import("@/views/authentification/ResetPasswordPage.vue"),
      props: route => ({ token: route.query.token })
    },

    {
      path: "/",
      component: () => import("@/views/BaseApp.vue"),
      children: BaseAppRouter,
      meta: {
        requiresAuth: true
      }
    },

    // Projects
    {
      path: "/projects",
      component: ProjectsBase,
      children: ProjectsRouter,
      meta: {
        goback: true,
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("jwt")

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {

      const { authorize } = to.meta;
      const currentUser = JSON.parse(localStorage.getItem("user"))

      if (authorize) {
        if (!currentUser) {
          // not logged in so redirect to login page with the return url
          return next({ path: "/login", query: { returnUrl: to.path } });
        }

        // check if route is restricted by role
        if (authorize.length && !authorize.includes(currentUser.role)) {

          if (currentUser.role === "SEWING") {
            return next("/plannings");
          }

          // role not authorised so redirect to home page
          return next({ path: "/" });
        }
      }

      next();

    }
  } else {
    next() // make sure to always call next()!
  }



});

// router.beforeEach(async (to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ["/login", "/forgot-password", "/reset-password"];
//   const authRequired = !publicPages.includes(to.path);
//   const onlyLogout = publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem("jwt");

//   if (authRequired && !loggedIn) {
//     return next("/login");
//   }

//   if (onlyLogout && loggedIn) {
//     return next("/");
//   }

//   const { authorize } = to.meta;
//   const currentUser = JSON.parse(localStorage.getItem("user"));

//   if (authorize) {
//     if (!currentUser) {
//       // not logged in so redirect to login page with the return url
//       return next({ path: "/login", query: { returnUrl: to.path } });
//     }

//     // check if route is restricted by role
//     if (authorize.length && !authorize.includes(currentUser.role)) {
//       // role not authorised so redirect to home page
//       if (currentUser.role === "SEWING") {
//         return next("/plannings");
//       }
//       return next("/");
//     }
//   }

//   next();
// });

export default router;
